import React, { useContext, useEffect, useState } from "react";
import { ILimitInputGroupProps } from "../../../../../type/componentsType/TkFakeTableLine";
import { Box, Typography } from "@mui/material";
import TkAmountInput from "../../../../molecules/TkAmountInput";
import "./_style.scss";
import TkPropertyMessageGet from "../../../../../utils/TkPropertyMessageGet";
import { TkFormContext } from "../../../../../context/tkFormContext";

const LimitInputGroup: React.FC<ILimitInputGroupProps> = (props) => {
  const {
    wantToSetValue,
    onChange,
    error,
    errorMessage,
    onGetValue,
    disabledMax,
    disabledMin,
  } = props;

  const [inputValue, setInputValue] = useState<{
    max: number | undefined;
    min: number | undefined;
  }>({ min: 0, max: 0 });
  const [minErrorInInput, setMinErrorInInput] = useState("");
  const [maxErrorInInput, setMaxErrorInInput] = useState("");
  const { formContext, setFormContext } = useContext(TkFormContext);

  useEffect(() => {
    if (wantToSetValue) {
      setInputValue(wantToSetValue);
      onChange && onChange(wantToSetValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantToSetValue]);

  useEffect(() => {
    const min = inputValue.min;
    const max = inputValue.max;
    if (min && min > 999999999) {
      setMinErrorInInput(TkPropertyMessageGet("TKMSG_SCR0048E", "999999999"));
    } else if (min && min < 0) {
      setMinErrorInInput(TkPropertyMessageGet("TKMSG_SCR0047E", "0"));
    }

    if (max && max > 999999999) {
      setMaxErrorInInput(TkPropertyMessageGet("TKMSG_SCR0048E", "999999999"));
    } else if (max && max < 1) {
      setMaxErrorInInput(TkPropertyMessageGet("TKMSG_SCR0047E", "1"));
    }
  }, [inputValue]);

  const handleChange =
    (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const newInputValue = {
        ...inputValue,
        [key]: event.target.value,
      };

      let changeValue: any = { target: { value: null } };

      if (newInputValue.max && newInputValue.min) {
        const newMin = newInputValue.min;
        const newMax = newInputValue.max;
        if (isNaN(newMin) || isNaN(newMax)) {
          setFormContext({
            preventSubmit: {
              ...formContext.preventSubmit,
              LimitInputGroup: true,
            },
          });

          changeValue = { target: { value: { ...newInputValue } } };
        } else {
          if (formContext?.preventSubmit?.LimitInputGroup)
            setFormContext({
              preventSubmit: {
                ...formContext.preventSubmit,
                LimitInputGroup: false,
              },
            });
          setMaxErrorInInput("");
          setMinErrorInInput("");
          changeValue = { target: { value: { min: newMin, max: newMax } } };
        }

        if (newMin && newMax && newMin > newMax) {
          setFormContext({
            preventSubmit: {
              ...formContext.preventSubmit,
              LimitInputGroup: true,
            },
          });
          setMaxErrorInInput(TkPropertyMessageGet("TKMSG_SCR0047E", "下限額"));
          setMinErrorInInput(TkPropertyMessageGet("TKMSG_SCR0048E", "上限額"));
        } else {
          if (formContext?.preventSubmit?.LimitInputGroup)
            setFormContext({
              preventSubmit: {
                ...formContext.preventSubmit,
                LimitInputGroup: false,
              },
            });
          setMaxErrorInInput("");
          setMinErrorInInput("");
        }
      }

      setInputValue(newInputValue);
      onChange && onChange(changeValue);
      onGetValue && onGetValue({ ...newInputValue });
    };

  return (
    <Box className="limitInputGroup">
      <Typography className="text">下限額</Typography>
      <TkAmountInput
        error={error || !!minErrorInInput}
        errorMessage={errorMessage || minErrorInInput}
        onChange={handleChange("min")}
        wantToSetValue={wantToSetValue?.min}
        inputProps={{ maxLength: 9 }}
        disabled={disabledMin}
      />
      <Typography>　～　</Typography>
      <Typography className="text">上限額</Typography>
      <TkAmountInput
        error={error || !!maxErrorInInput}
        errorMessage={errorMessage || maxErrorInInput}
        onChange={handleChange("max")}
        wantToSetValue={wantToSetValue?.max}
        inputProps={{ maxLength: 9 }}
        disabled={disabledMax}
      />
    </Box>
  );
};

export default LimitInputGroup;
